module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldCondIt.c4c1e5e.ttf";